import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import styled from 'styled-components';
import { colors, Regular } from './Styles';

export type SectionListPaginationProps = {
  loading?: boolean;
  currentPage: number;
  hasNextPage: boolean;
  onPrevPage: () => void;
  onNextPage: () => void;
};

export const SectionListPagination: React.FC<SectionListPaginationProps> = ({
  loading = false,
  currentPage,
  hasNextPage,
  onPrevPage,
  onNextPage,
}) => {
  const busy = !!loading;

  return (
    <Root>
      <NavButton type="button" onClick={onPrevPage} disabled={busy || currentPage === 1} title="Previous page">
        <FiChevronLeft size={18} />
      </NavButton>
      <PageLabel>
        <Regular color={colors.grey} weight="600">
          Page {currentPage}
        </Regular>
      </PageLabel>
      <NavButton type="button" onClick={onNextPage} disabled={busy || !hasNextPage} title="Next page">
        <FiChevronRight size={18} />
      </NavButton>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  gap: 14px;
`;

const NavButton = styled.button`
  all: unset;
  cursor: pointer;
  border: 1px solid ${colors.faintGrey};
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const PageLabel = styled.div`
  min-width: 90px;
  text-align: center;
`;
